import React, { useState, useEffect } from "react";
import { Container } from "react-bootstrap";
import { fetchPublicCategories } from "api/auth";
import { PublicCategory } from "interfaces/ICategory";
import { useBreakpoints } from "hooks/useBreakPoints";
import "./AllCategories.scss";
import CustomNavbarClients from "components/clients/components/navBarClients/CustomNavbarClients";
import ClientMenuBar from "../ClientMenuBar";
import { primaryColor } from "utils/colors";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";

const AllCategories: React.FC = () => {
  const [categories, setCategories] = useState<PublicCategory[]>([]);
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();
  const filteredCategories = categories.filter((category) =>
    category.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const { isMobile } = useBreakpoints();

  useEffect(() => {
    const loadCategories = async () => {
      try {
        const response = await fetchPublicCategories();
        setCategories(response);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };

    loadCategories();
  }, []);

  /**
   * Handles navigation to search page with selected category
   * @param {number} categoryId - The ID of the category to filter by
   */
  const handleCategoryClick = (categoryId: number) => {
    navigate(`/search?categories=${categoryId}`);
  };

  return (
    <>
      <CustomNavbarClients />
      <ClientMenuBar />
      <Container fluid className="all-categories-section">
        <div className="d-flex align-items-center justify-content-center">
          {!isMobile && (
            <div
              style={{
                height: "1px",
                background: primaryColor,
                flex: 1,
                maxWidth: "32%",
                boxShadow: "2px 4px 3px rgba(0,0,0,0.6)",
              }}
            />
          )}
          <h1
            style={{
              color: "black",
              fontWeight: "bold",
              fontSize: isMobile ? "40px" : "64px",
              letterSpacing: "3%",
              display: "flex",
              alignItems: "center",
              marginLeft: isMobile ? "3rem" : "4rem",
              marginRight: isMobile ? "3rem" : "4rem",
            }}
          >
            CATEGORÍAS
          </h1>

          {!isMobile && (
            <div
              style={{
                height: "1px",
                background: primaryColor,
                flex: 1,
                maxWidth: "32%",
                boxShadow: "2px 4px 3px rgba(0,0,0,0.6)",
              }}
            />
          )}
        </div>
        <div
          className="d-flex justify-content-end"
          style={{
            padding: "0 2rem",
            marginRight: isMobile ? "0rem" : "3rem",
          }}
        >
          <div
            className="position-relative"
            style={{
              width: isMobile ? "80%" : "33%",
              background: "none",
              marginRight: isMobile ? "0rem" : "2rem",
            }}
          >
            <input
              type="text"
              placeholder="Buscar categorías..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="form-control"
              style={{
                borderRadius: "10px",
                paddingRight: "40px",
                background: "none",
                border: "1px solid #000000",
                outline: "none",
                boxShadow: "none",
              }}
              onFocus={(e) => (e.target.style.border = "1px solid #B3812D")}
              onBlur={(e) => (e.target.style.border = "1px solid #000000")}
            />

            <FontAwesomeIcon
              icon={faSearch}
              style={{
                position: "absolute",
                right: "15px",
                top: "50%",
                transform: "translateY(-50%)",
                color: "black",
              }}
            />
          </div>
        </div>
        <div className="categories-grid">
          {filteredCategories.length > 0 ? (
            filteredCategories.map((category) => (
              <div
                key={category.id}
                className="category-card"
                onClick={() => handleCategoryClick(category.id)}
                style={{ cursor: "pointer" }}
              >
                <div className="image-container">
                  <img src={category.images[0]} alt={category.name} />
                </div>
                <div className="category-name">
                  <h3>{category.name}</h3>
                </div>
              </div>
            ))
          ) : (
            <div
              className="d-flex flex-column align-items-center"
              style={{
                gridColumn: "1 / -1",
                justifyContent: "center",
                textAlign: "center",
              }}
            >
              <h2
                style={{
                  fontSize: "3rem",
                  fontWeight: "bold",
                  color: "black",
                  marginBottom: "1rem",
                  marginTop: "2rem",
                }}
              >
                No se encontraron resultados
              </h2>
              <FontAwesomeIcon
                icon={faSearch}
                style={{
                  width: "9rem",
                  height: "9rem",
                  color: "black",
                  marginTop: "2rem",
                }}
              />
            </div>
          )}
        </div>
      </Container>
    </>
  );
};

export default AllCategories;
